export default defineNuxtRouteMiddleware(async (to, from) => {
	if(import.meta.client){
		if(!window.reloadTnChat)
			return;
		if (!document.querySelector("#tn-chat--form-wrapper.tn-chat--invisible")) {
			// No ongoing chats
			window?.reloadTnChat(`https://${window.location.host}${to.fullPath}`);
		}
	}
});
